import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import TeamsConfigView from '../views/TeamsConfigView.vue'
import type { RouteRecordRaw } from 'vue-router'
import { jwtDecode } from 'jwt-decode'
import authService from '@/services/authService'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: HomeView,
    meta: { requiresAuth: true },
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
  },
  {
    path: '/teams-config',
    name: 'TeamsConfig',
    component: TeamsConfigView,
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('token') // Store the JWT in local storage
  const msalToken = localStorage.getItem('msal_token') // Microsoft authentication token
  const teamsToken = localStorage.getItem('teams_token') // Teams authentication token

  if (to.meta.requiresAuth) {
    // Check if user is authenticated via Teams
    if (teamsToken && localStorage.getItem('teams_user')) {
      next() // Proceed to the route
      return
    }

    // Check if user is authenticated via Microsoft
    if (msalToken && authService.isAuthenticated()) {
      next() // Proceed to the route
      return
    }

    // Check traditional JWT token
    if (!token) {
      next({ name: 'Login' }) // Redirect to login if no token
    } else {
      // Decode the token to check expiration
      try {
        const decodedToken = jwtDecode<{ exp: number }>(token) // Specify the type for decoding
        const currentTime = Date.now() / 1000 // Current time in seconds

        if (decodedToken.exp < currentTime) {
          localStorage.removeItem('token') // Remove expired token
          next({ name: 'Login' }) // Redirect to login if token is expired
        } else {
          next() // Proceed to the route
        }
      } catch (error) {
        localStorage.removeItem('token') // Remove invalid token
        next({ name: 'Login' }) // Redirect to login if token is invalid
      }
    }
  } else {
    // Allow access to the login page if the token exists
    if (to.name === 'Login' && (token || msalToken || teamsToken)) {
      next({ name: 'Home' }) // Redirect to home if already logged in
    } else {
      next() // Proceed to the route
    }
  }
})

export default router
